import { api } from './client'

export type AgentStatus = {
  connected: boolean
  model: string
  key_prefix: string | null
}

export type AgentChatResponse = {
  session_id: string
  message: string
  tool_calls_made: string[]
}

export type AgentSession = {
  id: string
  project_id: number | null
  first_message: string | null
  last_message_at: string | null
  turn_count: number
  created_at: string
}

export async function getAgentStatus(): Promise<AgentStatus> {
  return api<AgentStatus>('/me/agent')
}

export async function setAgentKey(apiKey: string, model = 'claude-sonnet-4-6'): Promise<AgentStatus> {
  return api<AgentStatus>('/me/agent', { method: 'PUT', body: { api_key: apiKey, model } })
}

export async function clearAgentKey(): Promise<void> {
  return api<void>('/me/agent', { method: 'DELETE' })
}

export async function agentChat(message: string, sessionId?: string, projectId?: number): Promise<AgentChatResponse> {
  return api<AgentChatResponse>('/agent/chat', {
    method: 'POST',
    body: { message, ...(sessionId ? { session_id: sessionId } : {}), ...(projectId ? { project_id: projectId } : {}) },
  })
}

export async function listAgentSessions(): Promise<AgentSession[]> {
  return api<AgentSession[]>('/agent/sessions')
}
